import styled from 'styled-components';

const InfoBuildingStyle = styled.div`
	--distanceItemInfo: var(--sp3x);
	--radiusApartment: var(--sp2-5x);
	--apartmentTB: var(--sp5x);
	--apartmentLR: var(--sp4x);
	--distanceInfoTitleDescription: var(--sp1x);

	@keyframes opacity {
		from {
			opacity: 0;
		}
		to {
			opacity: 1;
		}
	}

	.wrapper-info {
		animation: opacity var(--trTime) ease-out forwards;
	}

	.apartment-info {
		aspect-ratio: 7 / 1;
		height: fit-content;
		border-radius: var(--radiusApartment);
		background-color: var(--white);
		padding: var(--apartmentTB) var(--apartmentLR);
		flex-direction: column;
		gap: var(--distanceItemInfo);
		display: flex;
	}

	.item-info {
		flex-direction: column;
		gap: var(--distanceInfoTitleDescription);
		display: flex;
	}

	/* //! 1920 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeXLMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeL}) {
		--distanceItemInfo: var(--sp3x);
		--radiusApartment: var(--sp2-5x);
		--apartmentTB: var(--sp5x);
		--apartmentLR: var(--sp4x);

		.apartment-info {
			aspect-ratio: 5 / 1;
		}
	}
	/* //! 1510 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeLMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeM}) {
		--distanceItemInfo: var(--sp3x);
		--radiusApartment: var(--sp2x);
		--apartmentTB: var(--sp4x);
		--apartmentLR: var(--sp2-5x);

		.apartment-info {
			aspect-ratio: 5 / 1;
		}
	}
	/* //! 1440 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeMMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeS}) {
		--distanceItemInfo: var(--sp2x);
		--radiusApartment: var(--sp2x);
		--apartmentTB: var(--sp3x);
		--apartmentLR: var(--sp2x);

		.apartment-info {
			aspect-ratio: 6 / 1;
		}
	}
	/* //! 1280 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeSMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeXS}) {
		--distanceItemInfo: var(--sp2x);
		--radiusApartment: var(--sp2x);
		--apartmentTB: var(--sp2-5x);
		--apartmentLR: var(--sp2x);

		.apartment-info {
			aspect-ratio: 7 / 1;
		}
	}
	/* //! 1024 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeXSMin}) and (min-width: ${(props) => props.theme.mediaQuery.TabletSize}) {
		--distanceItemInfo: var(--sp2x);
		--radiusApartment: var(--sp2x);
		--apartmentTB: var(--sp4x);
		--apartmentLR: var(--sp2x);

		.apartment-info {
			aspect-ratio: 4 / 1;
		}
	}
	/* //! 768 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeMin}) and (min-width: ${(props) => props.theme.mediaQuery.TabletSizeS}) {
		display: none;
	}
	/* //! 414 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeSMin}) {
		display: none;
	}
`;
export default InfoBuildingStyle;
